import { Pipe, PipeTransform } from '@angular/core';
import { ImpersonationDuration } from '../../../../models/impersonation-enums';

export const ImpersonationLocalizationKeys = {
  OneDay: 'oneDay',
  FiveDays: 'fiveDays',
  TenDays: 'tenDays',
  ThreeSixtyFiveDays: 'threeSixtyFiveDays'
};

@Pipe({
  name: 'caImpersonationDurationLocalizationKey',
  standalone: true
})
export class ImpersonationDurationLocalizationKeyPipe implements PipeTransform {
  transform(type: ImpersonationDuration | string): string {
    const key = type as keyof typeof ImpersonationDuration;
    return ImpersonationLocalizationKeys[key];
  }
}
